<template>
  <div
    v-if="!lazy || loaded || active"
    v-show="active"
    :id="`pane-${paneName}`"
    :aria-labelledby="`tab-${paneName}`"
    :aria-hidden="!active"
    :style="{ padding: computedPadding }"
    class="rt-tab-pane el-tab-pane"
    role="tabpanel"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'RtTabPane',

  componentName: 'ElTabPane',

  props: {
    label: String,
    labelContent: Function,
    name: String,
    closable: Boolean,
    disabled: Boolean,
    lazy: Boolean,
    padding: String
  },

  inject: ['rootTabs'],

  data () {
    return {
      index: null,
      loaded: false
    };
  },

  computed: {
    isClosable () {
      return this.closable || this.$parent.closable;
    },
    active () {
      const active = this.$parent.currentName === (this.name || this.index);
      if (active) {
        this.loaded = true;
      }
      return active;
    },
    paneName () {
      return this.name || this.index;
    },
    computedPadding () {
      if (this.padding) {
        return this.padding;
      }
      if (this.rootTabs && this.rootTabs.tabPanePadding) {
        return this.rootTabs.tabPanePadding
      }
      return '';
    }
  },

  updated () {
    this.$parent.$emit('tab-nav-update');
  }
};
</script>



// WEBPACK FOOTER //
// tab-pane.vue?a52456ce